import { ACTION_NAMES } from '@/constants/actionNames';
import Repository from './repository';

const resource = '/cfm/forms';

export default {
	create(payload) {
		return Repository.postWithAuth(
			`${resource}`,
			payload,
			{ 'x-action-name': ACTION_NAMES.CREATE_FORM_TEMPLATE },
			{ noCache: true }
		);
	},

	update(formId, payload) {
		return Repository.postWithAuth(
			`${resource}/${formId}`,
			payload,
			{ 'x-action-name': ACTION_NAMES.UPDATE_FORM_TEMPLATE },
			{ noCache: true }
		);
	},

	getById(formId) {
		return Repository.getWithAuth(
			`${resource}/${formId}`,
			{},
			{},
			{ noCache: true }
		);
	},

	getAll(params = {}) {
		return Repository.getWithAuth(
			`${resource}`,
			{},
			{},
			{ noCache: true, params }
		);
	},

	delete(formId) {
		return Repository.deleteWithAuth(
			`${resource}/${formId}`,
			{},
			{ 'x-action-name': ACTION_NAMES.DELETE_FORM_TEMPLATE },
			{ noCache: true }
		);
	},
};
